function calculateDistance(x1, y1, x2, y2) {
    const xDistance = x2 - x1;
    const yDistance = y2 - y1;
    const distance = xDistance * xDistance + yDistance * yDistance;
    return distance;
}

// this could be moved to store probably
function getKNearestPorts(px, py, ports, K) {
    const dists = ports.map(function (port, index) {
        return [
            index,
            calculateDistance(
                px,
                py,
                port.lat,
                port.lon
            ),
        ];
    });

    const indexes = dists
        .sort(function (a, b) {
            return a[1] - b[1];
        })
        .slice(0, K)
        .map((element) => element[0]);


    return indexes.map((index) => ports[index]);
}

// function getKNearestPoints(px, py, coordinatesList, K) {
//     const dists = coordinatesList.map(function (coords, index) {
//         return [
//             index,
//             calculateDistance(
//                 px,
//                 py,
//                 coords[1],
//                 coords[0]
//             ),
//         ];
//     });

//     const indexes = dists
//         .sort(function (a, b) {
//             return a[1] - b[1];
//         })
//         .slice(0, K)
//         .map((element) => element[0]);

//     return indexes.map((index) => coordinatesList[index]);
// }



export default getKNearestPorts